<template>
    <v-container class="inputContainer">
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span>処理中です...</span>
        </v-overlay>

        <add-input-component :templateInputShow="templateInputShow" @addText="addText" @addSelect="addSelect" @addCheckbox="addCheckbox" @addSeal="addSeal" />

        <v-row justify="center">
            <v-card
                color="grey lighten-3"
                >
                <v-tabs
                    v-model="fileTab"
                    dark
                    background-color="grey"
                    show-arrows
                >
                    <v-tabs-slider></v-tabs-slider>
    
                    <v-tab
                        v-for="(pdfObj, index) in Object.entries(this.pdfs)"
                        :key="pdfObj[0]"
                        :disabled="pdfLoading"
                        v-on:click="changePdf(pdfObj[0])"
                    >
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <span
                                class="info-to file_name"
                                v-bind="attrs"
                                v-on="on"
                                >
                                    {{ pdfObj[1].filename | omittedText }}
                                </span>
                            </template>
                            <span>{{ pdfObj[1].filename }}</span>
                        </v-tooltip>

                    </v-tab>
                </v-tabs>
                <template-pdf-document-component
                    v-for="(pdfObj, index) in Object.entries(this.pdfs)"
                    :key="pdfObj[0]"
                    v-show="currentPdfId==pdfObj[0]"
                    scale="1"
                    :url="baseUrl+pdfObj[0]"
                    :pdfId="pdfObj[0]"
                    :destinations="destinations"
                    :colorsIdMap="colorsIdMap"
                    :bgColorsIdMap="bgColorsIdMap"
                    :createUserId="createUserId"
                    :registeredInputs="registeredInputs[pdfObj[0]]"
                    :maxObjId="maxObjId"
                    ref="document"
                    @loading="loading"
                    @updateInput="updateInput"
                    />
            </v-card>
            <v-card
                width="200px"
            >
                <v-card-title>
                    凡例
                </v-card-title>
                <destination-list-component
                    :destinations="destinations"
                    :colors="colors"
                    :bgcolors="bgcolors"
                >
                </destination-list-component>
            </v-card>
        </v-row>
        <v-row justify="center">
            <v-col
                cols="2"
            >
                <v-btn
                    block
                    color="red"
                    class="white--text"
                    v-on:click="next"
                >
                    編集終了
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { colorList, bgColorList, colorListIdMap } from '../../common/colorUtil.js';
    export default {
        props: ['destinations', 'pdfs', 'createUserId', 'objId', 'registeredInputs', 'maxObjId'],
        data: function () {
            return {
                fileTab: 0,
                inputs: {},
                inputNum: 0,
                currentPdfId: 0,
                pdfLoading: false,
                baseUrl: '',
                pdfIdMap: {},
                colors: [],
                bgcolors: [],
                colorsIdMap: {},
                bgColorsIdMap: {},
                message: {
                    success: false,
                    text: '',
                },
                sending: false,
                templateInputShow: false,
            };
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        filters: {
            omittedText(text) {
             // 11文字目以降は"…"
             return text.length > 10 ? text.slice(0, 10) + "…" : text;
            },
        },
        created: function () {
            this.currentPdfId = Object.entries(this.pdfs)[0][0];
            // pdfの取得URL
            this.baseUrl = '/documents/document-management/template/' + this.objId + '/get-contract/';
            Object.entries(this.pdfs).forEach((val, i) => {
                this.pdfIdMap[val[0]] = i;
            });
            this.colors = colorList;
            this.bgcolors = bgColorList;
            let ids = [];
            this.destinations.forEach(val => {
                ids.push(val.id);
            });
            // 契約送付先IDと色のマッピング作成
            this.colorsIdMap = colorListIdMap(ids, colorList);
            this.bgColorsIdMap = colorListIdMap(ids, bgColorList);
            console.log(this.registeredInputs);
            this.inputs = Object.assign({}, this.registeredInputs);
        },
        methods: {
            changePdf: function (id) {
                this.currentPdfId = id;
            },
            loading: function (isLoading) {
                this.pdfLoading = isLoading;
            },
            saveInputs: async function () {
                let result = false;
                // upload server
                var response = await axios.post(
                    '/documents/document-management/template/'+this.objId+'/save_input',
                    {
                        'inputs': this.inputs,
                        'create_user_id': this.createUserId,
                    }
                )
                .catch(function (response) {
                    result = false;
                });
                result = response.data.success;
                if (response.data.message) {
                    this.message.text = response.data.message;
                    this.message.success = false;
                    // エラー対象のPDFを表示する
                    this.currentPdfId = response.data.fileId;
                    this.fileTab = Object.keys(this.pdfs).indexOf(response.data.fileId);
                    this.$refs.document[this.fileTab].currentPage = response.data.pageNum;
                }
                return result;
            },
            addText: function () {
                this.$refs.document[this.pdfIdMap[this.currentPdfId]].addText();
            },
            addSelect: function () {
                this.$refs.document[this.pdfIdMap[this.currentPdfId]].addSelect();
            },
            addCheckbox: function () {
                this.$refs.document[this.pdfIdMap[this.currentPdfId]].addCheckbox();
            },
            addSeal: function () {
                this.$refs.document[this.pdfIdMap[this.currentPdfId]].addSeal();
            },
            updateInput: function (pdfId, page, objectId, value) {
                // すべての契約書の入力項目更新（最終的にサーバへ送信するデータ）
                if (!(pdfId in this.inputs)) {
                    this.inputs[pdfId] = new Object();
                }
                if (!(page in this.inputs[pdfId])) {
                    this.inputs[pdfId][page] = new Object();
                }
                this.inputs[pdfId][page][objectId] = value;
            },
            next: async function() {
                this.sending = true;
                let result = false;
                try {
                    result = await this.saveInputs();
                } finally {
                    this.sending = false;
                }
                if (result) {
                    // 契約概要への遷移
                    window.location = '/documents/document-management/template/' + this.objId + '/over-view';
                }
            },
            // 保存
            save: async function() {
                return await this.saveInputs();
            },
        }
    };
</script>

<style>
    .file_name {
        font-size: 1.5rem !important;
    }
</style>